import instance from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';

export const getSurveyActs = (data: IDynamicTableParams) => {
  return instance()
    .post('/surveyAct/list', data)
    .then((response) => response.data);
};

export const getAvailableColumns = () => {
  return instance()
    .post('/surveyAct/availableColumns')
    .then((response) => response.data);
};

export const getAvailableGroupColumns = () => {
  return instance()
    .post('/surveyAct/availableGroupColumns')
    .then((response) => response.data);
};
